/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { map, get, noop } from 'lodash';

/**
 * Internal dependencies
 */
import FormMultiCheckbox from 'components/forms/form-multi-checkbox';

/**
 * Style dependencies
 */
import './styles.scss';

const SelectResources = ({ connection, onChange = noop, connectionType, defaultValues }) => {
    if (!connection || !connectionType) {
        return null;
    }

    const [values, setValues] = useState(defaultValues || []);

    const options = map(get(connectionType, 'config.availableResourceTypes', []), (v) => {
        return {
            value: v,
            label: v  // add translation
        };
    });

    const handleOnChange = (v) => {
        setValues(v);
        onChange(v);
    }    
 
    return (
        <Box>
            <FormMultiCheckbox onChange={handleOnChange} defaultChecked={defaultValues} options={options} />
        </Box>
    );
};

export default connect((state, ownProps) => {
    return {
        connectionType: get(state, ['connectionTypes', 'items', get(ownProps, 'connection.connection_type_id')]),
    };
}, {})(SelectResources);
